import CursorPaginatedAPI from "./CursorPaginatedAPI";
import axios from "axios";
import { store } from "@/store";
import { fileRoute } from "../routes";
import { newIdempotencyKey } from "@/composables/globalMethods";

export default class FileAPI extends CursorPaginatedAPI {
    constructor(emitterInstance) {
        super(emitterInstance, fileRoute, "file", 500);
    }

    async Add(formData, options = {}) {
        const { headers: extraHeaders, ...rest } = options;
        const result = await this._request("post", this._url(), formData, {
            fullResponse: true,
            timeout: 0, // large upload on slow mobile networks — no global timeout
            headers: {
                "Content-Type": "multipart/form-data",
                "Customer-ID": store.getters.domain,
                "Idempotency-Key": newIdempotencyKey(),
                ...(extraHeaders || {})
            },
            ...rest
        });
        this._emit("add", result.data.data);
        return result;
    }

    async Update(id, formData) {
        const result = await this._request("put", this._url(`/${id}`), formData, {
            fullResponse: true,
            timeout: 0, // large upload on slow mobile networks — no global timeout
            headers: {
                "Content-Type": "multipart/form-data",
                "Customer-ID": store.getters.domain
            }
        });
        this._emit("update", result.data.data);
        return result;
    }

    async GetByID(id) {
        return this._request("get", this._url(`/${id}`), null, {
            fullResponse: true,
            timeout: 0, // large file/image download — no global timeout
            responseType: "blob"
        });
    }

    async InitiateDirectUpload(file, metadata = {}) {
        return this._request(
            "post",
            this._url("/uploads"),
            {
                filename: file.name,
                size: file.size,
                content_type: file.type || "application/octet-stream",
                tags: metadata.tags || "",
                departments: metadata.departments || "",
                scope: metadata.scope || ""
            },
            {
                headers: {
                    "Customer-ID": store.getters.domain,
                    "Idempotency-Key": newIdempotencyKey()
                }
            }
        );
    }

    async CompleteDirectUpload(id) {
        return this._request("post", this._url(`/${id}/complete`), null, {
            headers: { "Customer-ID": store.getters.domain }
        });
    }

    async UploadDirect(file, metadata = {}, options = {}) {
        const pending = await this.InitiateDirectUpload(file, metadata);
        // The application-wide Axios client carries Forkto Authorization and
        // Customer-ID defaults. Never send those tenant credentials to GCS:
        // use a fresh client and strip inherited API-only headers before the
        // signed cross-origin request.
        const objectStorageClient = axios.create();
        objectStorageClient.defaults.headers.common = {};
        objectStorageClient.defaults.headers.put = {};
        await objectStorageClient.put(pending.upload_url, file, {
            timeout: 0,
            headers: pending.headers,
            signal: options.signal,
            onUploadProgress: options.onUploadProgress
        });
        const completed = await this.CompleteDirectUpload(pending.id);
        this._emit("add", completed.id);
        return completed;
    }

    async GetSignedURL(id) {
        return this._request("get", this._url(`/${id}/signed-url`), null, {
            headers: { "Customer-ID": store.getters.domain }
        });
    }
}
